export default __webpack_public_path__ + "static/media/optica.d86e3f34.png";